import { BillEntity, BillListStatus } from "../../domain";

export const BILL_STATUS_OPTIONS: Array<{
  label: string;
  value: BillListStatus;
}> = [
  { label: "All", value: "all" },
  { label: "Pending", value: "pending" },
  { label: "On Hold", value: "on_hold" },
  { label: "Under Review", value: "under_review" },
  { label: "Posted", value: "posted" },
  { label: "Duplicate", value: "duplicate" },
  { label: "Rejected", value: "rejected" },
];

export const getBillListStatus = (
  bill: BillEntity,
): Exclude<BillListStatus, "all"> => {
  if (Number(bill.is_under_review) === 1) {
    return "under_review";
  }

  if (bill.status === "3") {
    return "duplicate";
  }

  if (bill.status === "4") {
    return "rejected";
  }

  if (bill.status === "1" && bill.reviewed === "1") {
    return "posted";
  }

  if (Number(bill.on_hold) === 1) {
    return "on_hold";
  }

  return "pending";
};

export const getBillListStatusLabel = (status: BillListStatus) => {
  switch (status) {
    case "on_hold":
      return "On Hold";
    case "under_review":
      return "Under Review";
    case "posted":
      return "Posted";
    case "duplicate":
      return "Duplicate";
    case "rejected":
      return "Rejected";
    case "pending":
      return "Pending";
    case "all":
    default:
      return "All";
  }
};
